export const alignCenterMiddle = `
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
`;

export const alignCenter = (pos = 'relative') => `
  transform: translateX(-50%);
  position: ${pos};
  left: 50%;
`;

export const alignMiddle = `
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
`;
